export default "__VITE_ASSET__9a49a097__"